import { FC } from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";
import SearchDropdown from "./SearchDropdown";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import MenuBar from "shared/MenuBar/MenuBar";
import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import Avatar from "shared/Avatar/Avatar";
import ProfileDropdown from "./ProfileDropdown";
import { useSelector } from "react-redux";
import { RootState } from "store";
// import Notification from "shared/Notification";
// import Cart from "shared/Cart";
import { Link } from "react-router-dom";

export interface MainNav1Props {
  isTop: boolean;
}

const MainNav1: FC<MainNav1Props> = ({ isTop }) => {
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  // const { cartItem } = useSelector((state: RootState) => state.cart);

  return (
    <div
      className={`nc-MainNav1 relative z-10 ${
        isTop ? "onTop " : "notOnTop backdrop-filter"
      }`}
    >
      <div className="container py-5 relative flex justify-between items-center space-x-4 xl:space-x-8">
        <div className="flex justify-start flex-grow items-center space-x-4 sm:space-x-10 2xl:space-x-14">
          <Logo />
          <Navigation />
        </div>
        <div className="flex-shrink-0 flex items-center justify-end text-neutral-700 dark:text-neutral-100 space-x-1">
          <div className="hidden items-center lg:flex space-x-1">
            <SwitchDarkMode />
            <SearchDropdown />

            <div className="px-1" />

            {userInfo ? (
              <>
                {/* <Notification />
                <Cart data={cartItem ? cartItem : []} /> */}
                <div className="flex items-center">
                  <Link to="/account" className="flex items-center">
                    <Avatar
                      sizeClass={"w-8 h-8 mr-3"}
                      imgUrl={userInfo.avatar ? userInfo.avatar : "avatar.png"}
                    />
                  </Link>

                  <ProfileDropdown />
                </div>
              </>
            ) : (
              <ButtonPrimary href="/login">Masuk</ButtonPrimary>
            )}
          </div>
          <div className="flex items-center lg:hidden">
            <MenuBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
